import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { ViewService } from 'src/app/view/view.service';

@Component({
  selector: 'app-view-column',
  templateUrl: './view-column.component.html',
  styleUrls: ['./view-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class ViewColumnComponent implements OnInit {
  // ---------- Child Elements ----------
  @ViewChild('viewColumn') viewColumn: ElementRef<HTMLDivElement>;
  
  
  
  // ---------- Input / Ouput ----------
  @Input()
  unpadded = false;

  @Input()
  placement: 'left' | 'right' = 'left';



  // ---------- Lifecyle Events ----------
  constructor(
  ) { }

  ngOnInit() {
  }
  
}
